import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { TillpaymentsService } from './tillpayments.service';

angular.module('app-lite.tillpayments', [])
  .service('tillpaymentsApi', downgradeInjectable(TillpaymentsService));
